export const DEPARTMENT_DESIGNER = 'Thiết kế';
export const DEPARTMENT_SHIPPER = 'Giao hàng';

export interface EmployeeDataArray {
  rows: EmployeeItem[];
  total_rows: string;
}

export interface EmployeeItem {
  id: number;
  type: string;
  attributes: EmployeeModel;
}

export interface EmployeeModel {
  id: number;
  employee_code: string;
  name: string;
  date_of_birth: string;
  gender: string;
  phone: string;
  email: string;
  title: string;
  active: boolean;
  manager: string;
  manager_employee_id?: number | null;
  day_of_work: string;
  store_id: number;
  store_name: string;
  identity_number: string;
  department: string;
  basic_salary: number;
  /** Backend tính: có xoá được không (còn liên kết dữ liệu khác thì không) + lý do. */
  permission?: {
    allow_delete: boolean;
    delete_blocked_reason: string | null;
  };
  /** Mức lương đóng BHXH; null = không tham gia bảo hiểm. */
  insurance_salary: number | null;
  contract_type?: string | null;
  workday_type?: 'CC0' | 'CC1';
  standard_workdays?: number;
  salary_supplement?: number;
  payroll_allowances?: Record<string, number>;
  tax_dependents?: number;
  tax_method?: 'manual' | 'progressive';
  tax_number?: string | null;
  bank_name?: string | null;
  bank_account?: string | null;
  beneficiary_name?: string | null;
  bank_branch?: string | null;
  grade_level?: number | null;
  probation_start_date?: string | null;
  probation_end_date?: string | null;
  contract_signed_date?: string | null;
  contract_end_date?: string | null;
  healthcare_place?: string | null;
  identity_issued_date?: string | null;
  identity_issued_place?: string | null;
  education_level?: string | null;
  maternity_leave_from?: string | null;
  maternity_leave_to?: string | null;
  hr_note?: string | null;
  overtime_hourly_rate?: number | null;
  /** Địa chỉ tạm trú (cột `address` cũ). */
  address: string;
  permanent_address: string | null;
  social_insurance_number: string | null;
  health_insurance_number: string | null;
  avatar_url: string;
  bonues_trans: BonusTrans[];
  total_bonus_this_month: number;
  created_by: string;
  created_by_avatar_url?: string;
  /** Avatar của người quản lý, backend tra theo tên trong `manager`. */
  manager_avatar_url?: string;
  created_date: string;
}

export interface BonusTrans {
  id: number;
  trans_date: string;
  order_id: number;
  order_code: string;
  order_amount: number;
  customer_id: number;
  customer_name: string;
  bonus_percent: number;
  bonus_amount: number;
  employee_type?: string;
  remark?: string | null;
}

export interface EmployeeOption {
  label: string;
  value: number;
  avatar_url?: string;
  employee_code?: string;
  department?: string;
}

export interface EmployeeQueryParams {
  employee_code_or_name_or_email_cont?: string;
  name_cont?: string;
  page?: number;
  per_page?: number;
  sort?: {
    attribute: string;
    direction: string;
  };
}
